import React, { useState, useEffect, useContext } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import ImageComponent from 'atoms/Image';
import { ReactSVG } from 'react-svg';
import {
  getFullImagePath,
  getPrice,
  getPriceBasedOnShowPriceWithTaxFlag,
  isInDevMode,
  getTernaryValue,
  getAndCheck,
  isMobileDevice,
  displayBucketIcon,
  getAndCheckIfOneTrue,
  validateFlagAndCallFunc,
} from 'common/utilities/utils';

import { MENU_PLP_CONSTANT } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import MENU_CONSTANT from 'organisms/GenericMenuCategories/MenuConstants/MenuConstants';
import { QuantityModifier } from 'molecules/QuantityModifier';
import { shouldDisableButton } from 'organisms/MenusPLP/MenusPlpUtilities/MenusPlpUtils';
import { CustomizableItemModal } from 'organisms/CustomisationModal/index';
import { loggedIN, RESIZE } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';

const getSrcValue = (customlabelfield, discount, exclusive, newitem, topseller) => {
  return getTernaryValue(
    customlabelfield || discount || exclusive || newitem || topseller,
    IMAGE_PATH.ribbonRedOutlined,
    null,
  );
};

/**
 * PLP Menu Component
 */

export function PlpMenuCardViewComponent(props) {
  const {
    getCardTypeName,
    cardType,
    allowClickOnProductCard,
    discount,
    specials,
    exclusive,
    timer,
    cardId,
    customizable,
    getProductImageClassName,
    tenantData,
    imageName,
    onCardClickHandler,
    categoryId,
    categoryName,
    categoryUrl,
    dname,
    availability = [],
    newitem,
    topseller,
    customlabelfield,
    getSpecificRibbonBanner,
    userParams,
    favouriteItems,
    item,
    classFavouriteIconActive,
    getCardName,
    favouriteButtonClickHandler,
    itemCount,
    classFavouriteIconInActive,
    getMenuProductHeader,
    veg,
    servingCount,
    getVegNonvegClassName,
    menuProductPriceClassName,
    checkForBasePriceInMenu,
    baseprice,
    cardCat,
    displayPrice,
    getPriceClassName,
    menuProductDescriptionClassName,
    longDescription,
    updateItemQuantity,
    configureOptions,
    storeClosedData,
    classesCardButton,
    classEnableAddToCart,
    enableAddToCartButton,
    checkLoading,
    menuCardBtnText,
    clickHandler,
    itemFoodlineId,
    openCostomizedModal,
    setOpenCostomizedModal,
    filteredPreviousData,
    cartData,
    CARD_TYPE,
    setShowTopScrollBtn,
    pricewithouttax,
  } = props;
  const dispatch = useDispatch();
  const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;
  const { MINI_PDP_DATA, FROMFLAGEDIT, EDIT_CLICKED } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const [isEditSelection, setIsEditSelection] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { ITEM_QUANTITY } = MENU_CONSTANT;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const isLoggedIn = getTernaryValue(userParams?.loggedIn, loggedIN, '');
  const { allowAddToCartButton = true } = configureOptions;
  const { web: { global: { showPriceWithTax = false } = {} } = {} } = tenantData?.componentOptions ?? {};
  const {
    Non_veg_dot_Icon,
    Veg_dot_Icon,
    Product_Card_Icon,
    TimerIcon,
    FavoriteInActiveWhite,
    heartIcon_active,
    heartIcon_active_red,
    heartIcon_inactive_red,
  } = IMAGE_PATH;

  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  const priceMethod = () => {
    return (
      <div className={menuProductPriceClassName(cardType)}>
        {getAndCheck(
          checkForBasePriceInMenu(baseprice, cardCat),
          displayPrice(baseprice, tenantData?.currencyConversionFactor),
        )}
        <span className={getPriceClassName(baseprice, cardCat)}>
          {MENU_PLP_CONSTANT.MENU_CARD.CURRENCY}
          {getPriceBasedOnShowPriceWithTaxFlag(
            availability[0],
            pricewithouttax,
            tenantData?.currencyConversionFactor,
            showPriceWithTax,
          ).toFixed(2)}
        </span>
      </div>
    );
  };

  /*
   * RENDEV-14165 adding veg and non-veg icon for m-site in vegNonvegMethod
   */
  const vegNonvegMethod = () => {
    return (
      <div className={getVegNonvegClassName(cardType)}>
        {getAndCheck(
          isMobile,
          <img
            className='menu-vegOrNonVeg-icon'
            alt=' '
            src={getTernaryValue(!veg, Non_veg_dot_Icon, Veg_dot_Icon)}
          ></img>,
        )}
        {getAndCheck(
          !isMobile,
          getTernaryValue(
            !veg,
            translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.NON_VEG),
            translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.VEG),
          ),
        )}
        {getAndCheck(servingCount, <div className='Dot'></div>)}
        {MENU_PLP_CONSTANT.MENU_CARD.SERVES}
        {servingCount}
      </div>
    );
  };

  const heartIconClick = () => {
    if (userParams?.loggedIn) {
      return (
        <picture>
          <source
            media='(max-width: 1023px)'
            srcSet={getTernaryValue(
              getCardName === 'small-menu-product-card',
              getTernaryValue(
                Array.isArray(favouriteItems) && favouriteItems.find(el => el?.id === item?.id),
                classFavouriteIconActive(cardType),
                classFavouriteIconInActive(cardType),
              ),
              getTernaryValue(
                Array.isArray(favouriteItems) && favouriteItems.find(el => el?.id === item?.id),
                heartIcon_active_red,
                heartIcon_inactive_red,
              ),
            )}
            alt={''}
            className={`menu-product-save ${isLoggedIn}`}
            data-testid='fav-item-source'
            onClick={() => favouriteButtonClickHandler()}
          />
          <source
            media='(min-width: 1023px)'
            srcSet={getTernaryValue(
              Array.isArray(favouriteItems) && favouriteItems.find(el => el?.id === item?.id),
              heartIcon_active,
              FavoriteInActiveWhite,
            )}
            alt={''}
            className={`menu-product-save ${isLoggedIn}`}
            data-testid='fav-item-largeScreen'
            onClick={() => favouriteButtonClickHandler()}
          />
          <img
            src={
              getAndCheck(
                Array.isArray(favouriteItems),
                favouriteItems?.find(el => el?.id === item?.id),
              )
                ? heartIcon_active
                : FavoriteInActiveWhite
            }
            alt={''}
            className={`menu-product-save ${isLoggedIn}`}
            data-testid={`save-product-${cardId}`}
            onClick={() => favouriteButtonClickHandler()}
          />
        </picture>
      );
    }
  };

  const productImageComponent = () => {
    return (
      <ImageComponent
        data-testid='product-image'
        className={getProductImageClassName(cardType)}
        defaultPath={getFullImagePath(null, tenantData, true)}
        srcFile={getFullImagePath(imageName, tenantData)}
        onClick={e =>
          validateFlagAndCallFunc(allowClickOnProductCard, onCardClickHandler, [
            e,
            cardId,
            customizable,
            categoryId,
            {
              productName: dname,
              productImage: imageName,
              productPrice: getPriceBasedOnShowPriceWithTaxFlag(
                availability[0],
                pricewithouttax,
                tenantData?.currencyConversionFactor,
                showPriceWithTax,
              ),
            },
          ])
        }
        alt=''
      />
    );
  };
  const renderQuantityModifier = (itemCountValue, updateItemQuantityValue, dnameValue, maxItemCountPerLineItem) => {
    return (
      <QuantityModifier
        itemCount={itemCountValue}
        itemQuantity={ITEM_QUANTITY}
        updateItemQuantity={updateItemQuantityValue}
        quantityAction={QUANTITY_ACTION}
        item={undefined}
        itemName={dnameValue}
        maxItemCountPerLineItem={maxItemCountPerLineItem}
        cartItemCount={1}
        hideChild={true}
      />
    );
  };
  const renderCustomizableItemModal = () => {
    return (
      <CustomizableItemModal
        handleClose={() => {
          setOpenCostomizedModal(false);
          setIsEditSelection(false);
        }}
        filteredPreviousData={filteredPreviousData}
        updateItemQuantity={updateItemQuantity}
        tenantData={tenantData}
        dname={dname}
        clickHandler={clickHandler}
        cardId={cardId}
        categoryId={categoryId}
        categoryName={categoryName}
        categoryUrl={categoryUrl}
        itemCount={itemCount}
        availability={availability}
        pricewithouttax={pricewithouttax}
        imageName={imageName}
        itemFoodlineId={itemFoodlineId}
        customizable={customizable}
        setOpenCostomizedModal={setOpenCostomizedModal}
        openCostomizedModal={openCostomizedModal}
        cartData={cartData}
        setShowTopScrollBtn={setShowTopScrollBtn}
        foodId={props.item?.mdmId}
        isEditSelection={isEditSelection}
        headerText={getTernaryValue(
          isEditSelection,
          translateWithI18Next(MENU_PLP_CONSTANT.EDIT_QUANTITY),
          translateWithI18Next(MENU_PLP_CONSTANT.SELECT_QUANTITY),
        )}
      />
    );
  };

  const editSelectionsHandler = () => {
    if (itemCount === 1) {
      userOrderStateDispatch({
        type: MINI_PDP_DATA,
        value: { id: item?.mdmId, flag: FROMFLAGEDIT, foodLineId: itemFoodlineId },
      });
      userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
      userOrderStateDispatch({
        type: EDIT_CLICKED,
        value: { cartEditClicked: false },
      });
      dispatch(
        fetchItemDetailsAction({
          tenantId: tenantData?.tenantId,
          catalogName: cartData?.catalog,
          itemId: item?.mdmId,
        }),
      );
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: categoryId,
        }),
      );
    } else {
      setIsEditSelection(true);
      setOpenCostomizedModal(true);
    }
  };
  const productDeatilsData = {
    productId: cardId,
    productInfo: {
      productName: dname,
      productImage: imageName,
      productPrice: getPriceBasedOnShowPriceWithTaxFlag(
        availability[0],
        pricewithouttax,
        tenantData?.currencyConversionFactor,
        showPriceWithTax,
      ),
    },
  };
  const categoryDetails = {
    catId: categoryId,
    catName: categoryName,
    catUrl: categoryUrl,
  };
  const productDeatilsWrapper = {
    id: cardId,
    itemCount: itemCount,
    product: {
      productName: dname,
      productImage: imageName,
      productPrice: getPrice(availability[0], tenantData?.currencyConversionFactor),
    },
    itemFoodlineId: itemFoodlineId,
  };

  return (
    <>
      <div
        className={getCardTypeName(cardType, allowClickOnProductCard, discount, specials, exclusive, timer)}
        data-testid={`click-allow-on-product-${cardId}`}
        id={cardId}
      >
        {isInDevMode() && customizable && (
          <div className={`position-absolute p-2 m-1 bg-dark text-white rounded-pill`}>Customizable</div>
        )}
        {cardType !== CARD_TYPE.SMALL && productImageComponent()}
        <ReactSVG
          src={getTernaryValue(
            specials,
            Product_Card_Icon,
            getSrcValue(customlabelfield, discount, exclusive, newitem, topseller),
          )}
          className={getTernaryValue(
            specials,
            'specials-product-ribbon',
            getTernaryValue(
              getAndCheckIfOneTrue(exclusive, customlabelfield),
              'exclusive-product-ribbon',
              'discount-product-ribbon',
            ),
          )}
        />
        <span className={getTernaryValue(specials, 'specials-ribbon-text', 'discount-ribbon-text')}>
          {timer ? (
            <div>
              <ReactSVG src={TimerIcon} className='product-timer' />
              <span className='product-timer-text'>{translateWithI18Next(MENU_PLP_CONSTANT.MENU_CARD.TIMER)}</span>
            </div>
          ) : (
            getSpecificRibbonBanner(specials, discount, exclusive, newitem, topseller, customlabelfield)
          )}
        </span>
        {getAndCheck(!isMobile, heartIconClick())}
        <div
          className='menu-card-content'
          data-testid='menu-card-content-pdp-nav'
          onClick={categoryItem => {
            allowClickOnProductCard &&
              onCardClickHandler(categoryItem, productDeatilsData, customizable, categoryDetails);
          }}
        >
          <div
            className={getMenuProductHeader(cardType, discount, specials, exclusive, {
              timer,
              newitem,
              topseller,
              customlabelfield,
            })}
          >
            {dname?.[0].value}
          </div>
          {isMobile ? (
            <>
              <div className='description-and-image'>
                <div className={menuProductDescriptionClassName(cardType)} id='longDescription'>
                  {longDescription[0].value}
                </div>
                {cardType === CARD_TYPE.SMALL && productImageComponent()}
              </div>
              <div className='PriceVegNonveg'>
                {priceMethod()}
                {vegNonvegMethod()}
                <div className='hearticonDiv'>{heartIconClick()}</div>
              </div>
            </>
          ) : (
            <>
              <img
                className='menu-vegOrNonVeg-icon'
                alt=' '
                src={getTernaryValue(!veg, Non_veg_dot_Icon, Veg_dot_Icon)}
              ></img>
              {vegNonvegMethod()}
              {priceMethod()}
              <div className={menuProductDescriptionClassName(cardType)} id='longDescription'>
                {longDescription[0].value}
              </div>
            </>
          )}
        </div>
        <div className={`quantityAddtocart ${itemCount ? 'cardwithQuantity ' + isLoggedIn : 'cardwithNoquantity'}`}>
          {!!itemCount &&
            renderQuantityModifier(
              itemCount,
              updateItemQuantity,
              dname?.[0].value,
              tenantData?.maxItemCountPerLineItem,
            )}
          {allowAddToCartButton && storeClosedData && (
            <div className={classesCardButton(itemCount, isLoggedIn)}>
              {itemCount < 1 ? (
                <ButtonComp
                  tabIndex='0'
                  className={classEnableAddToCart(enableAddToCartButton, cardType, checkLoading, storeClosedData)}
                  data-testid={`add-to-cart-${cardId}`}
                  disabled={shouldDisableButton(storeClosedData)}
                  onClickHandler={event => {
                    if (menuCardBtnText(storeClosedData)?.enabled && itemCount <= 0) {
                      clickHandler(event, customizable, categoryDetails, productDeatilsWrapper);
                    }
                  }}
                  aria-label={menuCardBtnText(storeClosedData)?.btnText + dname?.[0].value}
                >
                  {menuCardBtnText(storeClosedData)?.btnText}
                  {displayBucketIcon(storeClosedData.isStoreClosed)}
                </ButtonComp>
              ) : (
                customizable && (
                  <span className='edit-selection' data-testid='edit-selection' onClick={() => editSelectionsHandler()}>
                    {translateWithI18Next(MENU_PLP_CONSTANT.EDIT_SELECTIONS)}
                  </span>
                )
              )}
            </div>
          )}
        </div>
      </div>
      <div>{openCostomizedModal && renderCustomizableItemModal()}</div>
    </>
  );
}

export default PlpMenuCardViewComponent;
